// extracted by mini-css-extract-plugin
export default {"SmallIcon":"ActivityNumberCard_SmallIcon__Cv7Yn","FormItem":"ActivityNumberCard_FormItem__UrNuF","Input":"ActivityNumberCard_Input__xoGex"};